import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const UpdateProfile = (store) => ({
  path: ROUTE.UPDATE_PROFILE,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'updateProfile',
    loadReducer: () => import('./UpdateProfileState'),
    loadComponent: () => import('./UpdateProfileContainer'),
  })
})

export default UpdateProfile
